import { EmptyState } from '@patternfly/react-core'
import { TableComposable, TableVariant, Tbody } from '@patternfly/react-table'
import * as React from 'react'

import type {
  ProgramEnrolmentStatusId,
  IPatientProgramInteraction,
} from '@app/domain/program/program.interface'

import { InteractionListHeader } from './interaction-list-header'
import { InteractionListRow } from './interaction-list-row'

interface Props {
  programEnrolmentStatus: ProgramEnrolmentStatusId
  patientProgramInteractions: IPatientProgramInteraction[]
  onSendInteractionToIntakeAnywhere: (programInteractionId: string) => void
  onRevokeInteraction: (programInteractionId: string) => void
  consentsToEmail: boolean
  consentsToSms: boolean
}

export const PatientProgramInteractionList = ({
  programEnrolmentStatus,
  onSendInteractionToIntakeAnywhere,
  onRevokeInteraction,
  patientProgramInteractions,
  consentsToEmail,
  consentsToSms,
}: Props) => {
  if (patientProgramInteractions) {
    return (
      <TableComposable
        variant={TableVariant.compact}
        borders={false}
        aria-label="Program Interactions"
        style={{ tableLayout: 'fixed' }}
      >
        <InteractionListHeader />
        <Tbody>
          {patientProgramInteractions.map((interaction, idx) => {
            return (
              <InteractionListRow
                key={idx}
                programEnrolmentStatus={programEnrolmentStatus}
                programInteraction={interaction}
                onSendInteractionToIntakeAnywhere={
                  onSendInteractionToIntakeAnywhere
                }
                onRevokeInteraction={onRevokeInteraction}
                consentsToEmail={consentsToEmail}
                consentsToSms={consentsToSms}
              />
            )
          })}
        </Tbody>
      </TableComposable>
    )
  } else {
    return <EmptyState>Program has no interactions.</EmptyState>
  }
}
